import React from 'react';
import './About.scss';
import EmailIcon from '@material-ui/icons/Email';
import aboutpic from './aboutpic.png'

function About() {
    return (
        <div className="about">
            <div className="about-container">
                <div className="about-imagecontainer">
                    <div className="about-avatar">
                        <img src={aboutpic} alt="milan george" />
                    </div>
                    <h1>Milan George</h1>

                </div>
                <div className="about-content">
                    <h4>My name is Milan George. I am currently an undergrad pursuing a Bachelors in Computer Science. I enjoy creating games that test my ability as a game programmer and try to make ones I'd play myself.
Looking forward to contributing to a team of like-minded individuals and making kickass games at the same time.
 If you would like me to join your team, feel free to contact me at any time.</h4>
                </div>
                <div className="about-contact">
                    <a href="mailto:mgeorge00747@gmail.com"><EmailIcon />  Contact Me</a>
                </div>
            </div>
        </div>
    )
}

export default About;
